export default "__VITE_ASSET__Dh7_lwZo__"